module.exports = __webpack_public_path__ + "img/title_cover.96fa0e1.png";